import { hasValues } from '@common/utils/typeGuards';
import { FALLBACK_LOCALES, SupportedLocaleCode } from '@constants/locales';

export const getLocalizedValue = <TKey extends string, TValue>(
    metadata: Record<string, Record<TKey, TValue>>,
    innerKey: TKey,
    locale: SupportedLocaleCode,
): TValue | undefined => {
    const searchOrder = [locale, FALLBACK_LOCALES[locale]];

    for (const locale of searchOrder) {
        const localeMetadata = metadata[locale];

        if (localeMetadata && localeMetadata[innerKey]) {
            return localeMetadata[innerKey];
        }
    }

    return undefined;
};

export const getLocalizedObject = <TInnerObject extends object>(
    localizedMap: Record<SupportedLocaleCode, TInnerObject | undefined>,
    locale: SupportedLocaleCode,
): TInnerObject | undefined => {
    const searchOrder = [locale, FALLBACK_LOCALES[locale]];

    for (const order of searchOrder) {
        const innerObject = localizedMap[order];

        if (innerObject) {
            const hasContent = hasValues(innerObject);
            if (hasContent) {
                return innerObject;
            }
        }
    }

    return undefined;
};
